import * as t from "io-ts";
const rowSnapshotT = t.record(t.string, t.unknown);
export const adminCargoHistoryEntryT = t.strict({
    historyId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminStopHistoryEntryT = t.strict({
    historyId: t.string,
    stopId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminChildHistoryEntryT = t.strict({
    historyId: t.string,
    rowId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminTemplateHistoryEntryT = t.strict({
    historyId: t.string,
    templateId: t.string,
    updatedAt: t.string,
    data: t.union([rowSnapshotT, t.null]),
});
export const adminCargoInspectT = t.strict({
    current: t.strict({
        id: t.string,
        ref: t.string,
        deleted: t.boolean,
        invoiced: t.boolean,
        invoiceRef: t.union([t.string, t.null]),
    }),
    clients: t.record(t.string, t.string),
    cargoHistory: t.array(adminCargoHistoryEntryT),
    stopHistory: t.array(adminStopHistoryEntryT),
    liveStops: t.array(rowSnapshotT),
    stopUnitHistory: t.array(adminChildHistoryEntryT),
    liveStopUnits: t.array(rowSnapshotT),
    extraCo2History: t.array(adminChildHistoryEntryT),
    liveExtraCo2: t.array(rowSnapshotT),
    stopUnitTemplateHistory: t.array(adminTemplateHistoryEntryT),
    stopUnitTemplateNames: t.record(t.string, t.string),
    extraCo2TypeHistory: t.array(adminTemplateHistoryEntryT),
    extraCo2Types: t.record(t.string, t.strict({ name: t.string, unit: t.union([t.string, t.null]) })),
    trackingStartedAt: t.strict({
        stops: t.union([t.string, t.null]),
        stopUnitsAndExtraCo2: t.union([t.string, t.null]),
    }),
});
//# sourceMappingURL=admin-cargo-inspect.js.map